import { render, staticRenderFns } from "./articleTable.vue?vue&type=template&id=dba23010&scoped=true"
import script from "./articleTable.vue?vue&type=script&lang=js"
export * from "./articleTable.vue?vue&type=script&lang=js"
import style0 from "./articleTable.vue?vue&type=style&index=0&id=dba23010&prod&scoped=true&lang=css"
import style1 from "./articleTable.vue?vue&type=style&index=1&id=dba23010&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba23010",
  null
  
)

export default component.exports